import { createContext } from 'react';
import { StoreRef } from './types';

export const ChatContext = createContext<StoreRef | null>(null);

export const ChatStoreContextConsumer = ChatContext.Consumer;
